import { Component } from '@angular/core';
import { SessionService } from '../shared/services/session/session.service';

@Component({
  selector: 'vit-info-bubble',
  templateUrl: 'info-bubble.component.html',
  styleUrls: ['info-bubble.component.scss']
})
export class InfoBubbleComponent {
  constructor(public sessionService: SessionService) {
  }
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/info-bubble/info-bubble.component.ts